module.exports = __webpack_public_path__ + "static/img/third14.bc6ecdfb.png";